












import {
  defineComponent, ref, watch,
} from '@vue/composition-api';

import Verte from 'verte';
import 'verte/dist/verte.css';

const CompanyColorsInput = defineComponent({
  components: {
    Verte,
  },
  props: {
    value: {
      type: Array,
      default: () => [
        { key: 'primary', colorCode: '#174681' },
        { key: 'secondary', colorCode: '#f9ae1b' },
      ],
    },
  },
  setup(props, context) {
    const primaryColor = ref('#174681');
    const secondaryColor = ref('#f9ae1b');

    const firstTimeWatch = ref(true);
    // HACK: It seems that Vue can't derived type from Array with default
    watch(() => props.value as { key: string; colorCode: string }[], (newValue) => {
      if (firstTimeWatch.value) {
        // props.value
        const priColor = newValue.find((c) => c.key === 'primary')?.colorCode.toUpperCase() !== primaryColor.value.toUpperCase();
        const secColor = newValue.find((c) => c.key === 'secondary')?.colorCode.toUpperCase() !== secondaryColor.value.toUpperCase();
        if (priColor || secColor) {
          primaryColor.value = newValue.find((c) => c.key === 'primary')?.colorCode || '#174681';
          secondaryColor.value = newValue.find((c) => c.key === 'secondary')?.colorCode || '#f9ae1b';
          firstTimeWatch.value = false;
        }
      }
    });

    const primaryColorChange = (colorCode: string) => {
      primaryColor.value = colorCode;
      context.emit('input', [
        { key: 'primary', colorCode },
        { key: 'secondary', colorCode: secondaryColor.value },
      ]);
    };

    const secondaryColorChange = (colorCode: string) => {
      secondaryColor.value = colorCode;
      context.emit('input', [
        { key: 'primary', colorCode: primaryColor.value },
        { key: 'secondary', colorCode },
      ]);
    };

    return {
      primaryColor,
      secondaryColor,
      primaryColorChange,
      secondaryColorChange,
    };
  },
});

export default CompanyColorsInput;
